import { render } from "./Characteristic.vue?vue&type=template&id=31df2692&scoped=true"
import script from "./Characteristic.vue?vue&type=script&lang=js"
export * from "./Characteristic.vue?vue&type=script&lang=js"

import "./Characteristic.vue?vue&type=style&index=0&id=31df2692&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31df2692"]])

export default __exports__